import axiosInstance from '../utils/axios';

const mapPointService = {
  getMyPoints: async () => {
    const response = await axiosInstance.get('map-points');
    return response.data;
  },

  createPoint: async (payload) => {
    const response = await axiosInstance.post('map-points', payload);
    return response.data;
  },

  getImportAddressCandidates: async (filters = {}) => {
    const response = await axiosInstance.get('map-points/import-addresses-candidates', {
      params: filters
    });
    return response.data;
  },

  importFromAddresses: async (filters = {}) => {
    const response = await axiosInstance.post('map-points/import-addresses', filters);
    return response.data;
  },

  deletePoint: async (id) => {
    const response = await axiosInstance.delete(`map-points/${id}`);
    return response.data;
  },

  deleteAllPoints: async () => {
    const response = await axiosInstance.delete('map-points');
    return response.data;
  }
};

export default mapPointService;
